<h2 mat-dialog-title>This VENOUS option is currently under construction.</h2>
<mat-dialog-content class="mat-typography">
  <p>
    Whilst under construction if you wish to order a venous kit for your patient,<br />
    please email orders&#64;tdlpathology.com and attach a completed request form <br />
    with the patient's address details to this email.
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>OK</button>
  <!--<button mat-button [mat-dialog-close]="false">Cancel</button>-->
</mat-dialog-actions>
